import { CustomCardColorBar, CustomPanel, PageHeader, PontuacaoCard } from '../../../../components'
import React from 'react'
import { azul, error, laranja, verde } from '../../../../assets/js/colors'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'

function EtapaCarregamento({ history }) {
  const etapaCarregamentoInfo = history.location.state.etapa_carregamento_info

  const { pontuacao_total, pontuacao_obtida, tp_name, carregamento_info } = etapaCarregamentoInfo

  // Helpers
  const getQteTotalEntregaParada = () => {
    return carregamento_info.reduce((total, item) => total + item.qte_total_entregas_paradas, 0)
  }

  const getQteAte3Dias = () => {
    return carregamento_info.reduce((total, item) => total + item.qte_ate_3dias, 0)
  }

  const getQteAte7Dias = () => {
    return carregamento_info.reduce((total, item) => total + item.qte_ate_7dias, 0)
  }

  const getQteAcima7Dias = () => {
    return carregamento_info.reduce((total, item) => total + item.qte_acima_7dias, 0)
  }

  // Render
  return (
    <>
      <PageHeader>
        Status Operação - &nbsp; <strong>Etapa Carregamento</strong>
      </PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-9">
              <h2>{tp_name}</h2>
            </div>
            <div className="p-col-3">
              <PontuacaoCard pontuacaoTotal={pontuacao_total} pontuacaoObtida={pontuacao_obtida} />
            </div>
            <div className="p-col-12">
              <CarregamentoInfo
                carregamentoInfo={carregamento_info}
                qteTotalEntregaParada={getQteTotalEntregaParada()}
                qteAte3Dias={getQteAte3Dias()}
                qteAte7Dias={getQteAte7Dias()}
                qteAcima7Dias={getQteAcima7Dias()}
              />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function CarregamentoInfo({
  carregamentoInfo,
  qteTotalEntregaParada,
  qteAte3Dias,
  qteAte7Dias,
  qteAcima7Dias,
}) {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Carregamento - Entregas Paradas</PageHeader>
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={azul}
          value={qteTotalEntregaParada}
          title={'Qte Paradas'}
          subTitle={'Qte total de entregas paradas'}
        />
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={verde}
          value={qteAte3Dias}
          title={'Qte Paradas Máximo 3 dias'}
          subTitle={'Qte de entregas paradas no MÁXIMO 3 dias'}
        />
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={laranja}
          value={qteAte7Dias}
          title={'Qte Paradas entre 4 e 7 dias'}
          subTitle={'Qte de entregas paradas ENTRE 4 e 7 dias'}
        />
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={error}
          value={qteAcima7Dias}
          title={'Qte Paradas acima de 7 dias'}
          subTitle={'Qte de entregas paradas ACIMA 7 dias'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={carregamentoInfo} emptyMessage={'Nenhum registro encontrado'}>
          <Column field={'empresa'} header={'Empresa'} />
          <Column
            field={'qte_total_entregas_paradas'}
            header={'TT. Entregas Paradas'}
            style={tableCellCentered(150)}
          />
          <Column
            field={'qte_ate_3dias'}
            header={'Paradas até 3 dias'}
            style={tableCellCentered(150)}
          />
          <Column
            field={'qte_ate_7dias'}
            header={'Paradas entre 4 e 7 dias'}
            style={tableCellCentered(150)}
          />
          <Column
            field={'qte_acima_7dias'}
            header={'Paradas acima 7 dias'}
            style={tableCellCentered(150)}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default withRouter(EtapaCarregamento)
